var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03212 10.9072L1.56056 7.00173C1.28538 6.69214 0.811322 6.66425 0.501735 6.93944C0.192148 7.21463 0.164263 7.68869 0.439451 7.99827L4.43945 12.4983C4.72614 12.8208 5.2252 12.8355 5.53034 12.5303L16.0303 2.03033C16.3232 1.73744 16.3232 1.26256 16.0303 0.96967C15.7374 0.676777 15.2626 0.676777 14.9697 0.96967L5.03212 10.9072Z",
    fill: "#D2D3E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/Shape1.74468e2912229bf442546c1dded45186.svg";
export { ForwardRef as ReactComponent };